import React from 'react';
import SkeletonLoader from 'Douleutaras/components/Loaders/SkeletonLoader';

const ProAboutTextLoader = () => {
  return (
    <>
      <SkeletonLoader type="line" />
      <SkeletonLoader type="line" />
      <SkeletonLoader type="line" />
      <SkeletonLoader type="line" maxWidth={300} />
    </>
  );
};

export default ProAboutTextLoader;
